import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './UserDashboardSideBarElements.module.scss';
import { ReactComponent as FilesIcon } from 'assets/icons/files.svg';
import { ReactComponent as FilesBlueIcon } from 'assets/icons/files-blue.svg';
import { ReactComponent as HouseIcon } from 'assets/icons/house.svg';
import { ReactComponent as HouseBlueIcon } from 'assets/icons/house-blue.svg';
import { ReactComponent as RobotIcon } from 'assets/icons/robot-ps.svg';
import { ReactComponent as RobotBlueIcon } from 'assets/icons/robot-ps-blue.svg';
import { ReactComponent as StudentIcon } from 'assets/icons/student.svg';
import { ReactComponent as StudentBlueIcon } from 'assets/icons/student-blue.svg';
import { ReactComponent as UserIcon } from 'assets/icons/user.svg';
import { ReactComponent as UserBlueIcon } from 'assets/icons/user-blue.svg';

const UserDashboardSideBarElements = () => {
  const location = useLocation();

  return (
    <ul className={`${styles.navPills} nav nav-pills d-flex flex-column`}>
      <li className="nav-item">
        <Link
          to="/home"
          className={`nav-link ${location.pathname.split('/').pop() === 'home' ? 'active' : ''}`}
          aria-current="page"
        >
          <span className="nav-icon">
            {location.pathname.split('/').pop() === 'home' ? <HouseBlueIcon /> : <HouseIcon />}
          </span>
          <span className="content">Dashboard</span>
        </Link>
      </li>
      <li className="nav-item">
        <Link
          to="/home/personal_information"
          className={`nav-link ${
            location.pathname.includes('personal_information') ? 'active' : ''
          }`}
          aria-current="page"
        >
          <span className="nav-icon">
            {location.pathname.includes('personal_information') ? <UserBlueIcon /> : <UserIcon />}
          </span>
          <span className="content">Profile</span>
        </Link>
      </li>
      {/* <li className="nav-item">
        <Link
          to="documents"
          className={`nav-link ${location.pathname.includes('documents') ? 'active' : ''}`}
          aria-current="page"
        >
          <span className="nav-icon">
            {location.pathname.includes('documents') ? <FilesBlueIcon /> : <FilesIcon />}
          </span>
          <span className="content">Documents</span>
        </Link>
      </li> */}
      <hr className="m-0" />
      <li className="nav-item">
        <Link
          to="/explore"
          className={`nav-link ${location.pathname.includes('explore') ? 'active' : ''}`}
          aria-current="page"
        >
          <span className="nav-icon bi bi-search" />
          <span className="content">Explore</span>
        </Link>
      </li>
      <li className="nav-item">
        <Link
          to="/home/shorlist"
          className={`nav-link ${location.pathname.includes('shorlist') ? 'active' : ''}`}
          aria-current="page"
        >
          <span
            className={`nav-icon ${
              location.pathname.includes('shorlist') ? 'bi-bookmark-fill' : 'bi-bookmark'
            }`}
          />
          <span className="content">Shortlist</span>
        </Link>
      </li>
      <li className="nav-item">
        <Link
          to="/home/applications"
          className={`nav-link ${location.pathname.includes('applications') ? 'active' : ''}`}
          aria-current="page"
        >
          <span className="nav-icon">
            {location.pathname.includes('applications') ? <StudentBlueIcon /> : <StudentIcon />}
          </span>
          <span className="content">Application</span>
        </Link>
      </li>
      <hr className="m-0" />
      <li className="nav-item">
        <Link
          to="https://unifyapply.com/our-end-to-end-service"
          className={`nav-link ${location.pathname.includes('our-service') ? 'active' : ''}`}
          aria-current="page"
        >
          <span className="nav-icon bi bi-gift" />
          <span className="content">Our services</span>
        </Link>
      </li>
      <li className="nav-item">
        <Link
          to="/personal-statement-builder"
          className={`nav-link ${
            location.pathname.includes('personal-statement-builder') ? 'active' : ''
          }`}
          aria-current="page"
        >
          <span className="nav-icon">
            {location.pathname.includes('personal-statement-builder') ? (
              <RobotBlueIcon />
            ) : (
              <RobotIcon />
            )}
          </span>
          <span className="content">PS builder</span>
        </Link>
      </li>
    </ul>
  );
};

export default UserDashboardSideBarElements;
